<template>
  <multiselect
    class="header-select"
    :searchable="searchable"
    :allow-empty="false"
    :show-labels="false"
    :value="value"
    :options="options"
    @mousedown.native.stop
    @touchstart.native.stop
    @input="onChange"
  >
    <template slot="singleLabel" slot-scope="props">
      <div class="select-option select-option-label">
        {{ props.option }}
      </div>
    </template>
    <template slot="option" slot-scope="props">
      <div class="select-option">
        {{ props.option }}
      </div>
    </template>
  </multiselect>
</template>

<script>
export default {
  name: "HeaderSelect",
  props: {
    value: [String],
    options: [Array],
    onChange: [Function],
    searchable: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.header-select {
  width: 100%;
  min-width: 0;
  min-height: 32px;
  box-sizing: border-box;
}
.header-select .multiselect__placeholder {
  margin: 0 0 0 6px;
  padding: 0;
}
.header-select .multiselect__tags {
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;
  min-height: 32px;
  padding-top: 0;
  padding-right: 40px;
  display: flex;
  align-items: center;
  border: 1px solid #eaeaea;
  overflow: hidden;
}

.header-select .multiselect__single {
  background: none;
  max-width: 100%;
  margin: 0;
  padding-left: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-select.multiselect--active .multiselect__single {
  display: none;
}

.header-select .multiselect__input {
  box-sizing: border-box;
  color: #000;
  font-size: 12px;
  font-weight: bold;
  height: 30px;
  line-height: 30px;
  margin: 0;
  min-width: 0;
  padding: 0;
  width: 300px;
  border: none;
}

.header-select.multiselect--active .multiselect__input {
  max-width: 100%;
  width: 137px !important;
  box-sizing: border-box;
}

.header-select .multiselect__input::placeholder {
  color: #666;
}

.header-select .multiselect__select {
  height: 32px;
}
.header-select .multiselect__select::before {
  border-color: #0821ff transparent transparent;
}

.header-select .multiselect__content-wrapper {
  border: none;
  background: none;
  margin: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.header-select .multiselect__option {
  background: #fff;
  font-size: 12px;
  color: #000;
}

.header-select .select-option {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  transition: color 0.3s ease-in;
  color: #000;
  cursor: pointer;
}
.header-select .select-option-label {
  overflow: hidden;
  white-space: nowrap;
}
.header-select .select-option-label,
.select-option:hover {
  color: #000;
}
</style>

<style scoped></style>
